import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const names = ['María', 'Laura', 'Carmen', 'Ana', 'Isabel', 'Sofía', 'Camila', 'Valentina', 'Martina', 'Lucía', 'Carlos', 'Juan', 'Pedro', 'Miguel'];
const locations = ['Buenos Aires, Argentina', 'Córdoba, Argentina', 'Rosario, Argentina', 'Santiago, Chile', 'Valparaíso, Chile', 'Bogotá, Colombia', 'Medellín, Colombia', 'Lima, Perú', 'Arequipa, Perú', 'Ciudad de México, México', 'Guadalajara, México', 'Madrid, España', 'Barcelona, España', 'Valencia, España'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    location: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = locations[Math.floor(Math.random() * locations.length)];
      setCurrentBuyer({
        name: randomName,
        location: randomLocation
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Hide after 4 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 5000);
    // Then random intervals between 15-30 seconds
    const intervalTimer = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, Math.floor(Math.random() * (30000 - 15000 + 1) + 15000));
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-127">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-6 left-6 z-50 bg-white border border-[#E8D5C0] shadow-2xl rounded-xl p-4 max-w-sm flex items-start gap-4" data-id="element-128">
          <div className="bg-[#EA580C]/15 p-2 rounded-lg flex-shrink-0 mt-1" data-id="element-129">
            <ShoppingBag className="w-5 h-5 text-[#EA580C]" data-id="element-130" />
          </div>
          <div data-id="element-131">
            <p className="text-sm text-[#5C2D0E]" data-id="element-132">
              <span className="font-bold text-[#3C1518]" data-id="element-133">
                {currentBuyer.name}
              </span>{' '}
              de {currentBuyer.location}
            </p>
            <p className="text-xs text-[#EA580C] mt-1 font-medium" data-id="element-134">
              acaba de comprar este producto.
            </p>
            <p className="text-[10px] text-[#A8763E] mt-1" data-id="element-135">
              Hace unos segundos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}